<template>
    <v-card class="full-width" v-if="tabPrefix.length > 0">
        <v-tabs v-model="active" :background-color="backgroundColor" :color="color" :slider-color="sliderColor" :dark="dark !== undefined ? dark : !!color">
            <v-tab v-for="tab in allowedTabs" exact :key="tab.key" :to="getLocation(tab.key)" ripple :disabled="tab.disabled">
                <slot name="selection" :item="tab">
                    {{ $t(tab.name) }}
                </slot>
            </v-tab>
        </v-tabs>
        <slot>
            <router-view />
        </slot>
    </v-card>
</template>

<script lang="ts" type="typescript">
    import Vue from "vue"
    import { Component, Prop, Watch } from "vue-property-decorator";
    import Apollo from "../lib/apollo";
    import ResourceCollection from "../lib/apollo/resourceCollection";

    export interface Tab {
        key: string,
        name: string,
        params: {},
        disabled?: boolean,
    }

    @Component
    export default class RouteTabs extends Vue {
        @Prop({default: ''})
        tabPrefix: string;

        @Prop()
        tabs: Tab[];

        @Prop({default: 0})
        defaultTab: number;

        @Prop({default: 'primary'})
        backgroundColor: string;

        @Prop({default: 'white'})
        color: string;

        @Prop({default: 'white'})
        sliderColor: string;

        @Prop({default: undefined})
        dark: boolean;

        @Prop()
        title: string;

        @Prop({
            default: () => {
            }
        })
        params: object;

        @Prop()
        allowed: string[];

        @Prop()
        relation: string ;

        /** In de omit modus laat hij eerst alles zien en haalt hij vervolgens de niet toegestaande tabs weg.
         * Anders laat hij eerst niks zien, en springen de tabs later in.
         */
        @Prop({type: Boolean, default: false})
        omitMode: boolean;

        allowedTabs: Tab[] =[];

        active: string = '';

        getLocation(key) {
            let result = {
                name: this.tabPrefix + key,
                params: this.params
            };

            if (this.title) {
                result.params['metaTitle'] = this.title
            }

            return result;
        }

//        get currentRouteName() {
//            return this.$route.name;
//        }
//
//        @Watch('currentRouteName')

        autoSelect(firstCheck = false) {
            if (typeof this.allowedTabs[this.defaultTab] === 'undefined') {
                return;
            }

            // zodat refreshen je niet naar het eerste tablad gooit
            if (firstCheck) {
                let found = false;

                this.tabs.forEach((tab: Tab) => {
                    if (found) {
                        return;
                    }

                    if (this.$route.name === this.tabPrefix + tab.key) {
                        found = true;
                    }
                });

                if (found) {
                    return;
                }
            }

            this.active = this.allowedTabs[this.defaultTab].key;
            this.$router.push({name: this.tabPrefix + this.active});
        }

        @Watch('relation')
        getAllowanceSettings() {
            if (!this.relation) {
                return;
            }

            Apollo.get('settings').all({
                relation: '/api/relations/' + encodeURIComponent(this.relation),
                key: 'postmaview_productdetail_' + this.relation
            }).then((res: ResourceCollection) => {
                if (res.items.length) {
                    this.checkAllowance(res.items[0].data);
                }
            });
        }

        @Watch('tabs')
        @Watch('allowed')
        checkAllowance(tabs) {
            let allowed = this.allowed;

            if (tabs) {
                allowed = tabs;
            }

            let allowedTabs = JSON.parse(JSON.stringify(this.tabs));

            if (!allowed || this.$store.state.user.roles.ROLE_ADMIN) {
                this.allowedTabs = allowedTabs;
                return;
            }

            this.tabs.forEach((tab: Tab) => {
                let index = allowed.indexOf(tab.key);

                if (index === -1) {
                    allowedTabs.splice(index, 1);
                }
            });

            this.allowedTabs = allowedTabs;

            this.autoSelect();
        }

        created() {
            if (this.allowed) {
                if (this.omitMode) {
                    this.checkAllowance(null);
                }
            } else {
                this.checkAllowance(null)
            }

            this.getAllowanceSettings();

            this.autoSelect(true);
        }
    }
</script>
